import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-6 text-body font-light leading-relaxed" data-id="element-43">
    <h2 className="text-3xl font-serif text-charcoal mb-6" data-id="element-44">
      Política de Privacidad
    </h2>
    <p className="text-sm text-muted uppercase tracking-widest mb-8" data-id="element-45">
      Última actualización: Febrero 2026
    </p>

    <h3 className="text-xl font-serif text-charcoal" data-id="element-46">
      1. Información que recopilamos
    </h3>
    <p data-id="element-47">
      Recopilamos únicamente la información que nos proporcionas voluntariamente
      al realizar una compra, como tu nombre y correo electrónico. No
      recopilamos datos sensibles ni información innecesaria.
    </p>

    <h3 className="text-xl font-serif text-charcoal" data-id="element-48">
      2. Uso de la información
    </h3>
    <p data-id="element-49">
      Tu información se utiliza exclusivamente para procesar tu compra y
      enviarte el producto digital adquirido. No compartimos, vendemos ni
      distribuimos tu información personal a terceros.
    </p>

    <h3 className="text-xl font-serif text-charcoal" data-id="element-50">3. Protección de datos</h3>
    <p data-id="element-51">
      Implementamos medidas de seguridad estándar de la industria para proteger
      tu información personal contra acceso no autorizado, alteración o
      destrucción.
    </p>

    <h3 className="text-xl font-serif text-charcoal" data-id="element-52">4. Cookies</h3>
    <p data-id="element-53">
      Este sitio puede utilizar cookies esenciales para el funcionamiento
      básico. No utilizamos cookies de seguimiento ni de publicidad.
    </p>

    <h3 className="text-xl font-serif text-charcoal" data-id="element-54">5. Tus derechos</h3>
    <p data-id="element-55">
      Tienes derecho a acceder, rectificar o eliminar tu información personal en
      cualquier momento. Para ejercer estos derechos, puedes comunicarte con
      nosotros a través de los canales disponibles.
    </p>
  </div>;
const termsContent = <div className="space-y-6 text-body font-light leading-relaxed" data-id="element-56">
    <h2 className="text-3xl font-serif text-charcoal mb-6" data-id="element-57">
      Términos y Condiciones
    </h2>
    <p className="text-sm text-muted uppercase tracking-widest mb-8" data-id="element-58">
      Última actualización: Febrero 2026
    </p>

    <h3 className="text-xl font-serif text-charcoal" data-id="element-59">1. Producto digital</h3>
    <p data-id="element-60">
      Barriga Rebelde (PERI) es un producto digital en formato PDF. Al completar
      tu compra, recibirás acceso inmediato al material. Debido a la naturaleza
      digital del producto, no se aceptan devoluciones una vez descargado.
    </p>

    <h3 className="text-xl font-serif text-charcoal" data-id="element-61">2. Uso personal</h3>
    <p data-id="element-62">
      El contenido adquirido es para uso personal y no puede ser reproducido,
      distribuido, compartido ni revendido sin autorización expresa por escrito.
    </p>

    <h3 className="text-xl font-serif text-charcoal" data-id="element-63">
      3. Descargo de responsabilidad
    </h3>
    <p data-id="element-64">
      Este material es informativo y educativo. No sustituye el consejo médico
      profesional. Si tienes una condición médica, trastorno alimenticio activo
      o cualquier preocupación de salud, consulta con un profesional antes de
      implementar cualquier cambio en tu alimentación.
    </p>

    <h3 className="text-xl font-serif text-charcoal" data-id="element-65">4. Resultados</h3>
    <p data-id="element-66">
      Los resultados pueden variar de persona a persona. No garantizamos
      resultados específicos, ya que dependen de múltiples factores
      individuales.
    </p>

    <h3 className="text-xl font-serif text-charcoal" data-id="element-67">
      5. Propiedad intelectual
    </h3>
    <p data-id="element-68">
      Todo el contenido, diseño, textos e imágenes de Barriga Rebelde están
      protegidos por derechos de autor. Queda prohibida su reproducción total o
      parcial sin consentimiento.
    </p>
  </div>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full px-6 py-8 bg-charcoal border-t border-white/5" data-id="element-69">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-70">
          <p className="text-xs text-white/20 tracking-widest uppercase" data-id="element-71">
            © 2026 Barriga Rebelde
          </p>
          <div className="flex items-center gap-6" data-id="element-72">
            <button onClick={() => setActiveModal('privacy')} className="text-xs text-white/30 hover:text-white/60 tracking-widest uppercase transition-colors duration-300" data-id="element-73">
              Privacidad
            </button>
            <span className="text-white/10" data-id="element-74">•</span>
            <button onClick={() => setActiveModal('terms')} className="text-xs text-white/30 hover:text-white/60 tracking-widest uppercase transition-colors duration-300" data-id="element-75">
              Términos
            </button>
          </div>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-76">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" onClick={() => setActiveModal(null)} data-id="element-77">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-charcoal/80 backdrop-blur-sm" data-id="element-78" />

            {/* Modal Content */}
            <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.98
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 10,
          scale: 0.98
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} onClick={e => e.stopPropagation()} className="relative bg-linen w-full max-w-2xl max-h-[80vh] overflow-y-auto shadow-2xl z-10" data-id="element-79">
              {/* Top accent line */}
              <div className="sticky top-0 left-0 w-full h-px bg-gradient-to-r from-rose via-gold to-rose" data-id="element-80" />

              {/* Close button */}
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center text-muted hover:text-charcoal transition-colors z-20" aria-label="Cerrar" data-id="element-81">
                <X className="w-5 h-5" data-id="element-82" />
              </button>

              {/* Content */}
              <div className="p-8 sm:p-12 pt-10" data-id="element-83">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}